<template>
  <generic-modal :title="$t('customer')" ref="generic_modal" :fullscreen="true">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("first names") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.first_name" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("last names") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.last_name" />
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("birth date") }}</label>
            <div class="control">
              <input type="date" class="input" v-model="meta.birth_date" />
            </div>
          </div>
        </div>
        <div class="column"></div>
      </div>
    </form>

    <div class="notification is-danger" v-if="error">
      {{ error }}
    </div>

    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import { generate_error_message_text, del, post, put, get } from "@/utils";

export default {
  name: "CustomerModal",
  components: { GenericModal },
  data() {
    let v = this;
    return {
      meta: {
        first_name: "",
        last_name: "",
        birth_date: "",
      },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      return (
        !this.meta.first_name || !this.meta.last_name || !this.meta.birth_date
      );
    },
  },
  methods: {
    show(uuid = null) {
      let v = this;
      v.$refs.generic_modal.show_modal();
      if (uuid) v.get_customer(uuid);
    },
    close() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    save() {
      let v = this;
      if (v.is_form_invalid) return;

      let data = { ...v.meta };

      if (v.meta.uuid) {
        post("/loan/customer", data)
          .then(() => {
            v.$emit("success");
            v.close();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        put("/loan/customer", data)
          .then(() => {
            v.$emit("success");
            v.close();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    get_customer(uuid) {
      let v = this;
      get("/loan/customer", { uuid: uuid })
        .then((response) => {
          v.meta = response;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        first_name: "",
        last_name: "",
        birth_date: "",
      };
      v.error = "";
    },
  },
};
</script>
